import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "./Button.jsx";
import SalaryCalculatorResult from "./SalaryCalculatorResult.jsx";
import modules from "../api/modules";
import i18n from "../i18n";
import { sendError } from "../errors.js";
import { markTaskAsDone, setLoading } from "../store";
import ErrorState from "./ErrorState.jsx";

/**
 * This is shown when the user sees the result the first time.
 */
export default function SalaryCalculator({ task, onNext, onRestart }) {
  const [data, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [income, setIncome] = useState("");
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function handleDoneClick() {
    await dispatch(markTaskAsDone(task));
    onNext();
  }

  function handleBackToTasklist() {
    navigate("/tasks");
  }

  useEffect(async () => {
    await dispatch(setLoading(true));
    try {
      setError(null);
      setData(await modules.fetchSalaryCalculatorData());
      if (data.income) {
        setIncome(data.income);
      }
      // TODO: What happens with the income????????
    } catch (err) {
      sendError(err);
      // TODO: some handing is needed here
      setError(err);
    }
    dispatch(setLoading(false));
    setLoaded(true);
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <section class="salary-calculator">
      {error ? <ErrorState /> : <SalaryCalculatorResult data={data} />}

      <div class="task-page__buttons">
        {error ? (
          <Button onClick={handleBackToTasklist}>
            {i18n.t("actions.back_to_tasklist")}
          </Button>
        ) : (
          <Button onClick={handleDoneClick}>{i18n.t("actions.done")}</Button>
        )}
        <Button text onClick={onRestart} class="mr-16">
          {i18n.t("actions.new_calculation")}
        </Button>
      </div>
    </section>
  );
}
